import styled, { css } from 'styled-components';

interface ContainerProps {
  isFilled: boolean;
  isFocuses: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  border-radius: 10px;
  border: 1px solid #454545;
  background-color: #3a3a3a;
  padding: 5px 10px;
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 44px;

  + div {
    margin-top: 8px;
  }

  > div {
    width: 100%;
    display: flex;
    align-items: center;
  }

  input {
    min-width: 100px;
    width: 100%;
    flex: 1;
    background: transparent;
    border: 0;
    color: #fff;
    transition-duration: 0.2s;

    ::placeholder {
      color: #bbbbbb;
    }

    :focus {
      border: none;
      outline: 0;
    }
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #ff333d;
    `}

  ${(props) => props.isFilled && css``}

  ${(props) =>
    props.isFocuses &&
    css`
      color: #606060;
      border-color: #606060;
    `}
`;

export const Tag = styled.div`
  border-radius: 100px;

  span {
    color: #bbbbbb;
  }
`;
